import {
  FiClock,
  FiEdit2,
  FiTrash2,
  FiMapPin
} from 'react-icons/fi';

function Timeline({
  projectTimeline = [],
  projectActors = [],
  editarTimeline,
  eliminarTimeline,
  onSelectEvent,
  territorialFilters = {
    selectedRegion: '',
    selectedComuna: '',
    selectedSector: '',
    selectedFoco: ''
  }
}) {
  const filteredTimeline = projectTimeline.filter((evento) => {
    return territorialMatch(evento, territorialFilters, projectActors);
  });

  const ordenado = [...filteredTimeline].sort(
    (a, b) => new Date(b.fecha) - new Date(a.fecha)
  );

  const hasActiveFilters =
    territorialFilters.selectedRegion ||
    territorialFilters.selectedComuna ||
    territorialFilters.selectedSector ||
    territorialFilters.selectedFoco;

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>Timeline Territorial</h2>

          <p style={styles.subtitle}>
            Cronología de hitos, reuniones, alertas y acciones relevantes del proyecto.
          </p>

          {hasActiveFilters && (
            <div style={styles.filterNotice}>
              Timeline filtrado por territorio activo
            </div>
          )}
        </div>

        <div style={styles.countBadge}>
          {ordenado.length} eventos
        </div>
      </div>

      {ordenado.length === 0 && (
        <p style={styles.empty}>
          No hay eventos registrados para el filtro territorial seleccionado.
        </p>
      )}

      <div style={styles.timeline}>
        {ordenado.map((evento) => (
          <div
  key={evento.id}
  style={styles.item}
  onClick={() => {
    if (onSelectEvent) {
      onSelectEvent(evento);
    }
  }}
>
            <div style={styles.line}>
              <div
  style={{
    ...styles.node,
    background: getEventColor(evento)
  }}
>
  <FiClock />
</div>
            </div>

            <div
  style={{
    ...styles.eventCard,
    ...(isCriticalEvent(evento)
      ? styles.criticalEventCard
      : {})
  }}
>
              <div style={styles.eventTop}>
                <div>
                  <div style={styles.date}>
                    {evento.fecha || 'Sin fecha'}
                  </div>

                  <h3 style={styles.eventTitle}>
                    {evento.titulo || 'Evento sin título'}
                  </h3>
                </div>

                <span style={styles.typeBadge}>
                  {evento.tipo || 'Evento'}
                </span>
              </div>

              <div style={styles.meta}>
                <FiMapPin />
                <span>
                  Actor relacionado: {evento.actor || 'Sin actor asociado'}
                </span>
              </div>

              <div style={styles.territoryMeta}>
                <span>{evento.region || 'Región no definida'}</span>
                <span>{evento.comuna || 'Comuna no definida'}</span>
                <span>{evento.sector || 'Sector no definido'}</span>
                <span>{evento.foco || 'Foco no definido'}</span>
              </div>

              <p style={styles.description}>
                {evento.descripcion || 'Sin descripción registrada.'}
              </p>

              <div style={styles.actions}>
                <button
                  style={styles.editButton}
                  onClick={() => editarTimeline(evento)}
                >
                  <FiEdit2 />
                  Editar
                </button>

                <button
                  style={styles.deleteButton}
                  onClick={() => eliminarTimeline(evento.id)}
                >
                  <FiTrash2 />
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function territorialMatch(item, filters, projectActors) {
  const {
    selectedRegion,
    selectedComuna,
    selectedSector,
    selectedFoco
  } = filters;

  const relatedActor = projectActors.find((actor) => {
    return (
      normalize(actor.nombre) === normalize(item.actor) ||
      normalize(actor.actor) === normalize(item.actor)
    );
  });

  const region = item.region || relatedActor?.region || '';
  const comuna = item.comuna || relatedActor?.comuna || '';
  const sector = item.sector || relatedActor?.sector || '';
  const foco = item.foco || relatedActor?.foco || '';

  if (selectedRegion && region !== selectedRegion) return false;
  if (selectedComuna && comuna !== selectedComuna) return false;
  if (selectedSector && sector !== selectedSector) return false;
  if (selectedFoco && foco !== selectedFoco) return false;

  return true;
}

function normalize(value) {
  return String(value || '').trim().toLowerCase();
}

function getEventColor(evento) {
  const tipo = String(evento.tipo || '').toLowerCase();

  if (
    tipo.includes('crítico') ||
    tipo.includes('critico') ||
    tipo.includes('conflicto')
  ) {
    return '#dc2626';
  }

  if (
    tipo.includes('alerta') ||
    tipo.includes('riesgo')
  ) {
    return '#f97316';
  }

  if (
    tipo.includes('reunión') ||
    tipo.includes('reunion')
  ) {
    return '#0891b2';
  }

  if (tipo.includes('acuerdo')) {
    return '#16a34a';
  }

  if (
    tipo.includes('rrss') ||
    tipo.includes('social')
  ) {
    return '#06b6d4';
  }

  return '#1fa97a';
}

function isCriticalEvent(evento) {
  const tipo = String(evento.tipo || '').toLowerCase();

  const descripcion = String(
    evento.descripcion || ''
  ).toLowerCase();

  return (
    tipo.includes('crítico') ||
    tipo.includes('critico') ||
    tipo.includes('conflicto') ||
    tipo.includes('crisis') ||
    tipo.includes('bloqueo') ||
    descripcion.includes('manifestación') ||
    descripcion.includes('manifestacion') ||
    descripcion.includes('denuncia')
  );
}

const styles = {
  card: {
    background: 'white',
    padding: '30px',
    borderRadius: '20px',
    boxShadow: '0 12px 35px rgba(7,26,47,0.08)',
    marginTop: '30px'
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '30px',
    gap: '20px'
  },

  title: {
    margin: 0,
    color: '#071a2f',
    fontSize: '30px'
  },

  subtitle: {
    color: '#667085',
    marginTop: '8px'
  },

  filterNotice: {
    display: 'inline-block',
    marginTop: '12px',
    background: '#ecfeff',
    color: '#0e7490',
    border: '1px solid #a5f3fc',
    padding: '7px 11px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: 'bold'
  },

  countBadge: {
    background: '#eef4ff',
    color: '#092395',
    padding: '10px 14px',
    borderRadius: '999px',
    fontWeight: 'bold',
    fontSize: '13px',
    whiteSpace: 'nowrap'
  },

  timeline: {
    position: 'relative'
  },

  item: {
  display: 'grid',
  gridTemplateColumns: '48px 1fr',
  gap: '14px',
  position: 'relative',
  marginBottom: '22px',
  cursor: 'pointer',
  transition: 'transform 0.18s ease'
},

  line: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center'
  },

  node: {
    width: '38px',
    height: '38px',
    borderRadius: '14px',
    background: 'linear-gradient(135deg,#1fa97a,#0993b5)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
    boxShadow: '0 8px 20px rgba(31,169,122,0.25)'
  },

  eventCard: {
    background: '#f8fafc',
    border: '1px solid #e4e7ec',
    borderRadius: '18px',
    padding: '20px',
    boxShadow: '0 8px 22px rgba(7,26,47,0.05)'
  },

  eventTop: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '14px',
    marginBottom: '12px'
  },

  date: {
    color: '#0993b5',
    fontWeight: 'bold',
    fontSize: '13px',
    marginBottom: '6px'
  },

  eventTitle: {
    margin: 0,
    color: '#071a2f',
    fontSize: '22px'
  },

  typeBadge: {
    background: '#ffffff',
    color: '#092395',
    border: '1px solid #dbeafe',
    padding: '7px 10px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: 'bold',
    height: 'fit-content',
    whiteSpace: 'nowrap'
  },

  meta: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#667085',
    fontSize: '14px',
    marginBottom: '12px'
  },

  territoryMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '12px'
  },

  description: {
    color: '#475467',
    lineHeight: '1.6'
  },

  actions: {
    display: 'flex',
    gap: '10px',
    marginTop: '16px'
  },

  editButton: {
    background: '#1fa97a',
    color: 'white',
    border: 'none',
    padding: '10px 14px',
    borderRadius: '12px',
    cursor: 'pointer',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },

  deleteButton: {
    background: '#dc2626',
    color: 'white',
    border: 'none',
    padding: '10px 14px',
    borderRadius: '12px',
    cursor: 'pointer',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },

  empty: {
    color: '#667085'
  }
};

export default Timeline;